module.exports = __webpack_public_path__ + "media/images/Decorative Fireplace-1686d26a.jpg";